import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {IntlProvider} from 'react-intl';
import {connect} from 'react-redux';

import {ConfigProvider} from 'antd';

import {LOCALES} from '@utils/locales/locales';

import {localizationActions} from '../../redux/modules/localization';
import {antdTheme} from '../../theme/designTokens';

export const LocalizationProvider = ({locale, antd, messages, initialize, children}) => {
  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IntlProvider locale={locale} messages={messages} textComponent="span">
      <ConfigProvider
        locale={antd}
        direction={[LOCALES.HE, LOCALES.AR].includes(locale) ? 'rtl' : 'ltr'}
        theme={antdTheme}
      >
        {children}
      </ConfigProvider>
    </IntlProvider>
  );
};

LocalizationProvider.propTypes = {
  locale: PropTypes.string,
  antd: PropTypes.object,
  messages: PropTypes.object,
  initialize: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

const mapStateToProps = ({localization}) => ({
  locale: localization.locale,
  messages: localization.messages,
  antd: localization.antd,
});

const mapDispatchToProps = (dispatch) => ({
  initialize: () => dispatch(localizationActions.initialize()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocalizationProvider);
